module.exports = __webpack_public_path__ + "static/img/right_logo_138x138.8861ab2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right_logo_138x138.gif
// module id = sOjR
// module chunks = 43